// angular
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';

// others
import { AppService } from '../../app.service';
import { AuthService } from '../../core/auth.service';
import { Router } from '@angular/router';
import { MeSelfReportService } from './me-self-report.service';
import { concatMap, from, tap } from 'rxjs';
import { thresholdFreedmanDiaconis } from 'd3';
import { KlenicoMeService } from '../me.service';

@Component({
    selector: 'me-self-report',
    templateUrl: './me-self-report.component.html',
    styleUrls: ['./me-self-report.component.scss'],
    providers: [MeSelfReportService]
})

export class MeSelfReportComponent implements OnInit {
    data: any;
    language = this.translate.currentLang;
    form: FormGroup;
    submitted: boolean;
    errorMessage = '';
    hidePassword = true;
    contents = [];
    showSuccessPage = false;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public coreService: CoreService,
        public translate: TranslateService,
        public authService: AuthService,
        public meService : KlenicoMeService,
        public meSelfReportService : MeSelfReportService,
        public router : Router
    ) {
    }

    ngOnInit() {
        this.appService.isLoading = true;
        this.meService.getDashboard().subscribe(res => {
            this.meSelfReportService.srStep = res['sr_step'];
            this.appService.isMePage = true;
            this.meSelfReportService.token = res['questionnaire_token'];
            this.meSelfReportService.patientId = res['patient_id'];
            let config = JSON.parse(this.appService.getMeClinicConfig());
            let steps = config?.selfEvaluationSteps;
            from(steps).pipe(
                tap(() => { this.appService.isLoading = true}),
                concatMap(step => this.appService.getStoryBlokSlugByUuid(step)),
                ).subscribe( response => {
                    this.contents.push(response['story']);
                },
                () => {},
                () => {
                    this.appService.isLoading = false;
                    this.data = this.contents[this.meSelfReportService.srStep];
                    if (!this.data) {
                        this.showSuccessPage = true;
                    }
                    if (this.data && this.data.content.component === 'selfEvaluationSelfReport') {
                        this.router.navigate(['self-evaluation/' + this.meSelfReportService.token]);
                    }
                }
            );
        });
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
    }

    updateUI() {
        this.data = this.contents[this.meSelfReportService.srStep];
        if (!this.data) {
            this.showSuccessPage = true;
            this.meSelfReportService.updatePatientStep(1);
            return;
        }


        if (this.data.content.component === 'selfEvaluationSelfReport') {
            this.router.navigate(['self-evaluation/' + this.meSelfReportService.token]);
        }
    }

    goToSR() {
        this.router.navigate(['me/self-evaluation']);
    }
}
